import { ObjectUtils } from './object-utils';

export class ApiData {

  public apiData: { [key: string]: any };

  protected mainBlock: { [key: string]: any } | null;
  protected mainContents: { [key: string]: any } | null;

  protected blocksBefore: { [key: string]: any }[];
  protected blocksAfter: { [key: string]: any }[];

  protected blocksNumbers = {
    total: 0,
    before: 0,
    after: 0,
    mainIndex: -1,
  };

  constructor(apiData: { [key: string]: any }) {
    const data = ObjectUtils.copy(apiData);
    this.apiData = data;

    this.blocksBefore = [];
    this.blocksAfter = [];

    this.mainBlock = null;
    this.mainContents = null;

    if (data.main_contents) {
      this.mainContents = data.main_contents;
    }

    if (data.blocks && (data.blocks || []).length) {
      this.blocksNumbers.total = (data.blocks || []).length;

      for (let i = 0; i < (data.blocks || []).length; ++i) {
        if (data.blocks[i].type === 'mainblock') {
          this.mainBlock = data.blocks[i];
          this.blocksNumbers.mainIndex = i;
          break;
        }
      }

      this.blocksNumbers.before = (this.blocksBefore || []).length;
      this.blocksNumbers.after = (this.blocksAfter || []).length;
    }
  }

  get mainblock(): { [key: string]: any } | null {
    return this.mainBlock;
  }

  get main_contents(): { [key: string]: any } | null {
    return this.mainContents;
  }

  hasMainblock(): boolean {
    return typeof this.mainBlock !== 'undefined' && this.mainBlock !== null;
  }

  hasMainContents(): boolean {
    return typeof this.mainContents !== 'undefined' && this.mainContents !== null;
  }

  typeIs(type: string): boolean {
    return this.hasMainContents()
      ? this.mainContents.content_type === type
      : false;
  }

}
